import { type IconSets } from "@toruslabs/vue-components";

export default {
  AppleIcon: () => import("@toruslabs/vue-icons/auth/AppleIcon"),
  ChevronLeftIcon: () => import("@toruslabs/vue-icons/arrows/ChevronLeftIcon"),
  CheckSolidIcon: () => import("@toruslabs/vue-icons/notifications/CheckSolidIcon"),
  CreditCardSolidIcon: () => import("@toruslabs/vue-icons/bank/CreditCardSolidIcon"),
  GoogleIcon: () => import("@toruslabs/vue-icons/auth/GoogleIcon"),
  LockClosedSolidIcon: () => import("@toruslabs/vue-icons/security/LockClosedSolidIcon"),
  XIcon: () => import("@toruslabs/vue-icons/notifications/XIcon"),
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  EyeSolidIcon: () => import("@toruslabs/vue-icons/security/EyeSolidIcon"),
} as unknown as IconSets;
